import { render, staticRenderFns } from "./Acompanhamento.vue?vue&type=template&id=5d8c5dae&"
import script from "./Acompanhamento.vue?vue&type=script&lang=js&"
export * from "./Acompanhamento.vue?vue&type=script&lang=js&"
import style0 from "../../assets/acompanhamento-comitente.styl?vue&type=style&index=0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports